import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { DragIndicator } from '@material-ui/icons';
import { TextField } from '@material-ui/core';
import Tooltip from '@mui/material/Tooltip';

const SubMenu = (props) => {
  const {
    categoryIndex,
    subCategoriesndx,
    subCategoriesData,
    onCategoryHover,
    onItemDragOver,
    category,
    setCategory,
    onDrop,
    onClickSubCategoryName,
    onClickCategoryAccordion,
    onDeleteCategory,
    onClickCategoryActive,
  } = props;

  function handledOnSubCategoryItemsDrag(result) {
    if (!result.destination) return;
    const items = Array.from(category[categoryIndex].subCategories[subCategoriesndx].items);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    category[categoryIndex].subCategories[subCategoriesndx].items = items;
    setCategory(category);
  }

  return (
    <>
      <div
        key={subCategoriesndx}
        className='row p-1'
        onMouseOver={(e) =>
          onCategoryHover(e, categoryIndex, true, 'subCategories', subCategoriesndx)
        }
        onMouseLeave={(e) =>
          onCategoryHover(e, categoryIndex, false, 'subCategories', subCategoriesndx)
        }
      >
        <div
          className='col-md-8 ird-menu-accordion-subcategory'
          onDragOver={(e) => onItemDragOver(e)}
          onDrop={(e) => onDrop(e, 'subCategory', categoryIndex, subCategoriesndx)}
        >
          <div className='ird-menu-accordion'>
            <div className='row mt-3 pb-2'>
              <div className='col-md-1'>
                <DragIndicator className='ird-menu-accordion-drag' />
              </div>
              <div className='col-md-8 ird-menu-accordion-text'>
                <span
                  onClick={(e) =>
                    onClickSubCategoryName(
                      e,
                      subCategoriesData,
                      subCategoriesndx,
                      categoryIndex,
                      'clicked',
                      true,
                    )
                  }
                >
                  {subCategoriesData.isEditable ? (
                    <TextField
                      id={subCategoriesndx + '_input'}
                      label='Sub-Category Name'
                      value={subCategoriesData.name}
                      required={true}
                      onChange={(e) =>
                        onClickSubCategoryName(
                          e,
                          subCategoriesData,
                          subCategoriesndx,
                          categoryIndex,
                          'change',
                        )
                      }
                      error={!subCategoriesData.name ? true : false}
                      helperText={!subCategoriesData.name && 'Sub category name required'}
                      type='text'
                      onBlur={(e) =>
                        onClickSubCategoryName(
                          e,
                          subCategoriesData,
                          subCategoriesndx,
                          categoryIndex,
                          'blur',
                          false,
                        )
                      }
                    />
                  ) : (
                    <p>{subCategoriesData.name}</p>
                  )}
                </span>
              </div>
              <div
                className='col-md-1'
                onClick={(e) =>
                  onClickCategoryActive(
                    e,
                    subCategoriesData,
                    categoryIndex,
                    subCategoriesndx,
                    null,
                    null,
                    'subCategories',
                  )
                }
              >
                <Tooltip
                  title={subCategoriesData.isActive ? 'Hide' : 'Unhide'}
                  placement='bottom-end'
                >
                  {subCategoriesData.isActive ? <RemoveRedEyeIcon /> : <VisibilityOffIcon />}
                </Tooltip>
              </div>
              <div
                className='col-md-1'
                onClick={(e) =>
                  onClickCategoryAccordion(
                    e,
                    categoryIndex,
                    subCategoriesData.isExpanded,
                    subCategoriesndx,
                    'subCategories',
                  )
                }
              >
                {subCategoriesData.isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </div>
            </div>
          </div>
        </div>
        {subCategoriesData.isHovered && (
          <div
            className='col-md-1 ird-hover-popup'
            onClick={(e) => onDeleteCategory(e, categoryIndex, 'subCategories', subCategoriesndx)}
          >
            <Tooltip title='Remove' placement='bottom-end'>
              <DeleteForeverIcon />
            </Tooltip>
          </div>
        )}
      </div>
      <DragDropContext onDragEnd={handledOnSubCategoryItemsDrag}>
        <Droppable droppableId='subItems'>
          {(provided) => (
            <div className='subItems' {...provided.droppableProps} ref={provided.innerRef}>
              {subCategoriesData.isExpanded &&
                subCategoriesData.items &&
                subCategoriesData.items.length > 0 &&
                subCategoriesData.items.map((itemsData, itemsNdx) => (
                  <Draggable key={itemsData.id} draggableId={itemsData.id} index={itemsNdx}>
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <div
                          key={itemsNdx}
                          className='row p-1'
                          onMouseOver={(e) =>
                            onCategoryHover(
                              e,
                              categoryIndex,
                              true,
                              'subCategoriesItem',
                              subCategoriesndx,
                              itemsNdx,
                            )
                          }
                          onMouseLeave={(e) =>
                            onCategoryHover(
                              e,
                              categoryIndex,
                              false,
                              'subCategoriesItem',
                              subCategoriesndx,
                              itemsNdx,
                            )
                          }
                        >
                          <div key={itemsNdx} className='col-md-8 ird-menu-accordion-items-div'>
                            <div className='ird-menu-accordion-items'>
                              <div className='row'>
                                <div className='col-md-1 mt-3'>
                                  <DragIndicator className='ird-menu-accordion-drag' />
                                </div>
                                <div className='col-md-9 ird-menu-accordion-text mt-3'>
                                  {itemsData.name}
                                </div>
                                <div
                                  className='col-md-1 mt-3'
                                  onClick={(e) =>
                                    onClickCategoryActive(
                                      e,
                                      itemsData,
                                      categoryIndex,
                                      subCategoriesndx,
                                      itemsNdx,
                                      null,
                                      'subCategoriesItem',
                                    )
                                  }
                                >
                                  <Tooltip
                                    title={itemsData.isActive ? 'Hide' : 'Unhide'}
                                    placement='bottom-end'
                                  >
                                    {itemsData.isActive ? (
                                      <RemoveRedEyeIcon />
                                    ) : (
                                      <VisibilityOffIcon />
                                    )}
                                  </Tooltip>
                                </div>
                              </div>
                            </div>
                          </div>
                          {itemsData.isHovered && (
                            <div
                              className='col-md-1 ird-hover-popup'
                              onClick={(e) =>
                                onDeleteCategory(
                                  e,
                                  categoryIndex,
                                  'subCategoriesItem',
                                  subCategoriesndx,
                                  itemsNdx,
                                )
                              }
                            >
                              <Tooltip title='Remove' placement='bottom-end'>
                                <DeleteForeverIcon />
                              </Tooltip>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );
};

export default SubMenu;
